import type { FC, ReactNode } from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface StatsCardProps {
  icon: ReactNode;
  title: string;
  value: string | number;
  subtitle: string;
}

export const StatsCard: FC<StatsCardProps> = ({ icon, title, value, subtitle }) => {
  return (
    <Card className="py-0">
      <CardContent className="flex min-h-[132px] flex-col justify-between p-4">
        <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-wide text-muted-foreground">
          {icon}
          {title}
        </div>
        <div>
          <div className="text-2xl font-semibold tracking-tight tabular-nums text-foreground">
            {value}
          </div>
          <p className="mt-1 text-xs text-muted-foreground">{subtitle}</p>
        </div>
      </CardContent>
    </Card>
  );
};
